import { inject } from '@angular/core';
import { App } from '@df/core/app';
import { ISites } from '@df/core/df-core.interfaces';

export function getSiteId(): keyof ISites {
    const app = inject(App);
    return app.dfConfig.ms.siteId;
}
